import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Provider } from "react-redux";
import createStore from "./store/createStore";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { CookiesProvider } from "react-cookie";
import App from './components/app/App';
import reportWebVitals from './reportWebVitals';

const store = createStore();

ReactDOM.render(
    <React.StrictMode>
        <CookiesProvider>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Provider store={store}>
                    <App />
                </Provider>
            </LocalizationProvider>
        </CookiesProvider>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
